import { motion } from "motion/react";
import type { FabAction } from "@/components/FabRegistry";
import { cn } from "@/lib/utils";

export function ResponsiveFab({ action }: { action: FabAction | null }) {
  if (!action) return null;

  const Icon = action.icon;
  return (
    <motion.button
      key={action.label}
      type="button"
      aria-label={action.label}
      onClick={action.onClick}
      whileHover={{ scale: 1.06, y: -2 }}
      transition={{ type: "spring", stiffness: 400, damping: 22 }}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.8 }}
      className={cn(
        "fixed bottom-20 right-4 z-30 inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-primary text-primary-foreground shadow-lg shadow-primary/30 sm:right-6",
        "ring-1 ring-primary/20 lg:bottom-6 lg:right-8 lg:w-auto lg:min-w-14 lg:gap-2 lg:px-5",
      )}
    >
      <Icon className="h-6 w-6" aria-hidden />
      <span className="hidden text-sm font-semibold lg:inline">{action.label}</span>
    </motion.button>
  );
}
